<template>
  <v-app-bar
    id="app-bar"
    app
    elevation="0"
    height="64"
    class="app-bar-clean"
  >
    <!-- Menu Toggle Button -->
    <v-btn
      icon
      class="menu-toggle mr-2"
      @click="setDrawer(!drawer)"
    >
      <v-icon color="#4a5568" size="22">
        {{ drawer ? 'mdi-menu-open' : 'mdi-menu' }}
      </v-icon>
    </v-btn>

    <!-- App Title/Route Name -->
    <div class="app-title-section">
      <v-toolbar-title class="app-title">
        <div class="d-flex align-center">
          <div>
            <div class="title-main">HRVEC</div>
            <div class="title-sub">{{ formatRouteName($route.name) }}</div>
          </div>
        </div>
      </v-toolbar-title>
    </div>

    <v-spacer />

    <!-- Notification Bell -->
    <v-menu offset-y left v-if="userProfile.aut === '1' || userProfile.aut === 1">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          class="notification-btn mr-2"
          v-bind="attrs"
          v-on="on"
          :loading="loading"
        >
          <v-badge
            :content="notifications.length"
            :value="notifications.length > 0"
            color="error"
            overlap
          >
            <v-icon color="#4a5568" size="22">mdi-bell-outline</v-icon>
          </v-badge>
        </v-btn>
      </template>
      <v-card class="notification-card" min-width="350">
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-bell</v-icon>
          การแจ้งเตือน
          <v-spacer></v-spacer>
          <v-chip small color="white" text-color="primary">{{ notifications.length }}</v-chip>
        </v-card-title>
        <v-list>
          <v-list-item
            v-for="(notification, index) in notifications"
            :key="index"
            @click="handleNotificationClick(notification)"
          >
            <v-list-item-avatar>
              <v-icon color="primary">mdi-information</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ notification.college_name }}</v-list-item-title>
              <v-list-item-subtitle>{{ notification.personnel_temporary_notifyDetail }}</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-chip x-small :color="notification.type">{{ notification.personnel_temporary_notifyDateTIme }}</v-chip>
              <v-btn icon><v-icon color="red" @click="delNotify(notification.personnel_temporary_notifyID)">mdi-delete</v-icon></v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="notifications.length === 0"></v-divider>
          <v-list-item v-if="notifications.length === 0">
            <v-list-item-content class="text-center">
              <v-icon size="48" color="grey lighten-2">mdi-bell-off</v-icon>
              <div class="text-subtitle-1 grey--text">ไม่มีการแจ้งเตือน</div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions v-if="notifications.length > 0">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="clearAllNotifications">
            ล้างทั้งหมด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!-- User Profile Menu -->
    <v-menu offset-y left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="user-profile-btn mr-2"
          v-bind="attrs"
          v-on="on"
          text
        >
          <v-avatar size="36" class="mr-2" color="#edf2f7">
            <v-img
              v-if="userProfile.avatar"
              :src="userProfile.avatar"
              alt="Profile"
            ></v-img>
            <v-icon v-else color="#2b6cb0" size="20">mdi-account-circle</v-icon>
          </v-avatar>
          <div class="user-info d-none d-md-block">
            <div class="user-name">{{ userProfile.name || 'ผู้ใช้งาน' }}</div>
            <div class="user-role">{{ userProfile.role || 'Admin' }}</div>
          </div>
          <v-icon color="#a0aec0" class="ml-1">mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      
      <v-card min-width="280">
        <v-card-text class="text-center pa-4">
          <v-avatar size="64" class="mb-3">
            <v-img
              v-if="userProfile.avatar"
              :src="userProfile.avatar"
              alt="Profile"
            ></v-img>
            <v-icon v-else color="primary" size="40">mdi-account-circle</v-icon>
          </v-avatar>
          <div class="text-h6 font-weight-bold">{{ userProfile.name || 'ผู้ใช้งาน' }}</div>
          <div class="text-subtitle-2 grey--text">{{ userProfile.email || 'user@example.com' }}</div>
          <v-chip small :color="userProfile.status === 'online' ? 'success' : 'grey'" class="mt-2">
            <v-icon left small>{{ userProfile.status === 'online' ? 'mdi-circle' : 'mdi-circle-outline' }}</v-icon>
            {{ userProfile.status === 'online' ? 'ออนไลน์' : 'ออฟไลน์' }}
          </v-chip>
        </v-card-text>
        
        <v-divider></v-divider>
        
        <v-list>            
          <v-list-item @click="goToSettings">
            <v-list-item-icon>
              <v-icon color="primary">mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>ตั้งค่า</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          
          <v-list-item @click="toggleTheme">
            <v-list-item-icon>
              <v-icon color="primary">{{ isDark ? 'mdi-brightness-7' : 'mdi-brightness-4' }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ isDark ? 'โหมดสว่าง' : 'โหมดมืด' }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <!-- Navigation Buttons -->
    <div class="nav-buttons">
      <v-btn
        class="nav-btn mr-1"
        text
        :to="'/admin/Dashboard'"
        exact
      >
        <v-icon left color="#4a5568">mdi-view-dashboard-outline</v-icon>
        <span class="d-none d-lg-inline nav-btn-text">Dashboard</span>
      </v-btn>

      <v-btn
        class="nav-btn mr-2"
        text
        :to="'/admin/home_menu'"
        exact
      >
        <v-icon left color="#4a5568">mdi-apps</v-icon>
        <span class="d-none d-lg-inline nav-btn-text">เมนูระบบ</span>
      </v-btn>
    </div>

    <!-- Logout Button -->
    <v-btn
      text
      class="logout-btn ml-2"
      @click="showLogoutDialog = true"
    >
      <v-icon left color="#e53e3e">mdi-logout</v-icon>
      <span class="d-none d-md-inline">ออกจากระบบ</span>
    </v-btn>

    <!-- Logout Confirmation Dialog -->
    <v-dialog v-model="showLogoutDialog" max-width="400">
      <v-card class="logout-dialog">
        <v-card-title class="warning white--text">
          <v-icon left color="white">mdi-logout</v-icon>
          ยืนยันการออกจากระบบ
        </v-card-title>
        
        <v-card-text class="pa-6">
          <div class="text-center">
            <v-icon size="64" color="warning" class="mb-4">mdi-help-circle-outline</v-icon>
            <div class="mb-2">คุณต้องการออกจากระบบหรือไม่?</div>
            <div class="grey--text">ข้อมูลที่ยังไม่ได้บันทึกอาจสูญหาย</div>
          </div>
        </v-card-text>
        
        <v-card-actions class="pa-6">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey"
            @click="showLogoutDialog = false"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            color="error"
            @click="confirmLogout"
            class="ml-2"
          >
            <v-icon left>mdi-logout</v-icon>
            ออกจากระบบ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Loading Overlay -->
    <v-overlay v-if="isLoggingOut" absolute>
      <v-progress-circular
        indeterminate
        size="64"
        color="white"
      ></v-progress-circular>
      <div class="text-center mt-4">
        <div class="white--text">กำลังออกจากระบบ...</div>
      </div>
    </v-overlay>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";

// Utilities
import { mapState, mapMutations } from "vuex";

export default {
  name: "DashboardUserAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "primary--text": !hover,
                    "white--text primary elevation-4": hover
                  },
                  props: {
                    activeClass: "primary white--text",
                    dark: hover,
                    link: true,
                    ...this.$attrs
                  }
                },
                this.$slots.default
              );
            }
          }
        });
      }
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    showLogoutDialog: false,
    isLoggingOut: false,
    isDark: false,
      ApiKey: "HRvec2021",
    
    // Enhanced notifications with more realistic data
    notifications: [],
    loading: false,
    // User profile data
    userProfile: {
      name: "ผู้ดูแลระบบ",
      email: "",
      role: "ผู้ดูแลระบบ",
      avatar: null, // Can be set to an image URL
      status: "online",
      aut: "admin"
    }
  }),

  computed: {
    ...mapState(["drawer"])
  },

  mounted() {
    this.loadUserProfile();
    this.personnel_temporary_notifyQueryAll();
    this.isDark = this.$vuetify.theme.dark;
  },

  methods: {
    delNotify(id) {
      this.$http.post("personnel_temporary_notify.delete.php", {
        personnel_temporary_notifyID: id,
        ApiKey: this.ApiKey,
      }).then(() => {
        this.notifications = this.notifications.filter(n => n.personnel_temporary_notifyID !== id);
      }).catch(() => {
        console.error("Error deleting notification");
      });

    },
     async personnel_temporary_notifyQueryAll() {
      this.loading = true;
      try {
        const result = await this.$http.post("personnel_temporary_notify.php", {
          ApiKey: this.ApiKey
        });
        this.notifications = result.data;
      } catch (error) {
        this.showSnackbar('เกิดข้อผิดพลาดในการโหลดข้อมูล', 'error');
      } finally {
        this.loading = false;
      }
    },



    ...mapMutations({
      setDrawer: "SET_DRAWER"
    }),

    formatRouteName(routeName) {
      if (!routeName) return 'ระบบจัดการ';
      
      const routeNames = {
        'Dashboard': 'แดชบอร์ด',
        'home_menu': 'เมนูหลัก',
        'personnel_temporary_notify': 'การแจ้งเตือนบุคลากร',
        'rate_work_std02': 'สถิตินักเรียนนักศึกษา',
        'personnel_etc': 'รายงานอัตรากำลัง',
        'temporarycollegeemreg': 'ประกาศรับสมัคร',
        'temporaryemployees': 'ผู้สมัครงาน'
      };
      
      return routeNames[routeName] || routeName;
    },

    loadUserProfile() {
      // Load user profile from session storage or API
      const userSession = JSON.parse(localStorage.getItem("user")) || {};
      if (userSession) {
        this.userProfile = {
          ...this.userProfile,
          name: userSession.user_firstname || userSession.user_name || this.userProfile.name,
          email: userSession.user_email || this.userProfile.email,
          role: userSession.user_status || this.userProfile.role,
          aut: userSession.userProfile || this.userProfile.aut,
        };
      }
    },

    handleNotificationClick(notification) {
      // Handle notification click
      // You can add navigation logic here
    },

    clearAllNotifications() {
      this.notifications = [];
    },

    goToProfile() {
      // Navigate to profile page
      this.$router.push('/admin/profile');
    },

    goToSettings() {
      // Navigate to settings page
      this.$router.push('/admin/setting');
    },

    toggleTheme() {
      this.isDark = !this.isDark;
      this.$vuetify.theme.dark = this.isDark;
      // Save theme preference
      localStorage.setItem('darkTheme', this.isDark);
    },

    async confirmLogout() {
      this.isLoggingOut = true;
      this.showLogoutDialog = false;
      
      try {
        // Simulate logout process
        await new Promise(resolve => setTimeout(resolve, 1500));        
        // Clear session data
        localStorage.clear();
        localStorage.removeItem('authToken');           
  
        this.$router.push("/");
      } catch (error) {
        console.error('Logout error:', error);
      } finally {
        this.isLoggingOut = false;
      }
    },

    // Legacy logout method for compatibility
    logout() {
      this.showLogoutDialog = true;
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Prompt:wght@300;400;500;600;700&display=swap");

.app-bar-clean {
  background: #ffffff !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
  font-family: 'Prompt', sans-serif;
}

.menu-toggle {
  transition: background 0.2s ease;
}

.app-title-section {
  margin-left: 4px;
}

.app-title {
  font-family: 'Prompt', sans-serif;
}

.title-main {
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1.2;
  color: #1a202c;
  letter-spacing: 0.02em;
}

.title-sub {
  font-size: 0.78rem;
  font-weight: 400;
  color: #a0aec0;
}

.notification-btn {
  transition: background 0.2s ease;
}

.notification-card {
  border-radius: 12px !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.user-profile-btn {
  border-radius: 10px !important;
  padding: 6px 12px !important;
  transition: background 0.2s ease;
}

.user-profile-btn:hover {
  background: #f7fafc !important;
}

.user-info {
  text-align: left;
  margin-left: 4px;
  margin-right: 4px;
}

.user-name {
  font-size: 0.87rem;
  font-weight: 600;
  color: #2d3748;
  line-height: 1.2;
}

.user-role {
  font-size: 0.72rem;
  color: #a0aec0;
  line-height: 1;
}

.profile-card {
  border-radius: 12px !important;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.12);
}

.nav-buttons .nav-btn {
  border-radius: 8px !important;
  transition: background 0.2s ease;
}

.nav-btn-text {
  color: #4a5568;
}

.nav-buttons .nav-btn:hover {
  background: #f7fafc !important;
}

.nav-buttons .nav-btn.v-btn--active {
  background: #ebf4ff !important;
}

.logout-btn {
  border-radius: 8px !important;
  transition: background 0.2s ease;
}

.logout-btn:hover {
  background: #fff5f5 !important;
}

.logout-dialog {
  border-radius: 15px !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .app-title-section {
    margin-left: 4px;
  }

  .title-main {
    font-size: 0.95rem;
  }

  .title-sub {
    display: none;
  }

  .user-profile-btn {
    padding: 4px 8px !important;
  }

  .nav-buttons {
    display: none;
  }
}

@media (max-width: 480px) {
  .notification-btn {
    margin-right: 4px !important;
  }

  .user-profile-btn {
    margin-right: 4px !important;
  }

  .logout-btn {
    margin-left: 8px !important;
    padding: 8px !important;
  }
}

/* Animation for notifications */
.v-badge >>> .v-badge__badge {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* Dark theme support */
.theme--dark .notification-card,
.theme--dark .profile-card,
.theme--dark .logout-dialog {
  background: #2d2d2d !important;
}

/* Loading overlay styling */
.v-overlay >>> .v-overlay__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Smooth transitions */
* {
  transition: all 0.3s ease;
}

/* Custom scrollbar for notification list */
.notification-card >>> .v-list {
  max-height: 300px;
  overflow-y: auto;
}

.notification-card >>> .v-list::-webkit-scrollbar {
  width: 4px;
}

.notification-card >>> .v-list::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.notification-card >>> .v-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.notification-card >>> .v-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>